import { AuraContext } from '@/types/models/AuraContextModel';

export interface AuraContextResponse {
    success: boolean;
    data: AuraContext;
}
